import { useGetApiV1ThreeLetterCodeClientAdminsStressAssessments } from '@fukuri-admins/apis/client/gen/endpoints';

export const useGetStressAssessmentList = useGetApiV1ThreeLetterCodeClientAdminsStressAssessments;
